import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Form, Input, Spin } from "antd";
import { useRef } from "react";
import toast from "react-hot-toast";
import { resetPassword } from "../../../features/auth/authSlice";
import AuthShell from "../AuthShell";

export default function ForgotPassword() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.auth);

  const onFinish = async (data) => {
    const res = await dispatch(
      resetPassword({
        email: data.usrEmail,
        url: "auth/forgot-password",
      })
    );

    if (res?.payload?.success) {
      toast.success(res.payload?.messages?.message);
      await navigate("/verify-forgot-email");
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };

  return (
    <AuthShell
      panelTitle="Forgot password"
      panelSubtitle="Enter your email address and we will help you reset your password."
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        style={{
          maxWidth: "100%",
        }}
        className="weiser-login-form"
        form={form}
      >
        <Form.Item
          label="Email address"
          className="login-form-item weiser-login-form-item"
          name="usrEmail"
          rules={[
            {
              required: true,
              message: "Please input your email",
            },
          ]}
        >
          <Input className="weiser-login-input" />
        </Form.Item>

        <button
          disabled={saving}
          className="weiser-login-submit"
          type="submit"
        >
          {saving ? <Spin /> : "Next"}
        </button>

        <div className="weiser-login-actions">
          <Link className="weiser-login-forgot forgot_text" to="/login">
            Back to login
          </Link>
        </div>
      </Form>
    </AuthShell>
  );
}
